<template>
  <el-popover ref="popover" placement="top" width="auto" trigger="click" @show="handleShow" @hide="removeOutsidePointerListener">
    <!-- 表情库共用语言状态；切换语言或重新打开时重建面板，确保当前弹层显示自己的文案。 -->
    <VEmojiPicker :key="`${pickerLocale}-${pickerVersion}`" :i18n="pickerTranslations" @select="selectEmoji" />
    <template v-slot:reference>
      <slot></slot>
    </template>
  </el-popover>
</template>
<script>
import { VEmojiPicker } from "v-emoji-picker";
// 第三方表情库默认只提供英文文案；其他页面继续使用原来的英文，工作台按当前语言显示。
const englishPickerText = {
  search: "Search ...",
  categories: {
    Activity: "Activity", Flags: "Flags", Foods: "Foods", Frequently: "Frequently",
    Objects: "Objects", Nature: "Nature", Peoples: "Peoples", Symbols: "Symbols", Places: "Places",
  },
};
const chinesePickerText = {
  search: "搜索表情",
  categories: {
    Activity: "活动", Flags: "旗帜", Foods: "食物", Frequently: "常用",
    Objects: "物品", Nature: "自然", Peoples: "人物", Symbols: "符号", Places: "地点",
  },
};
export default {
  components: {
    VEmojiPicker,
  },
  props: {
    localizeLabels: { type: Boolean, default: false },
    // 仅由需要区域外关闭行为的输入区开启，不改变其他页面的表情面板。
    closeOnOutsidePointer: { type: Boolean, default: false },
  },
  data() {
    return { pickerVersion: 0 };
  },
  computed: {
    pickerLocale() {
      return this.localizeLabels && !String(this.$i18n?.locale || "").toLowerCase().startsWith("en") ? "zh-CN" : "en";
    },
    pickerTranslations() {
      return this.pickerLocale === "zh-CN" ? chinesePickerText : englishPickerText;
    },
  },
  beforeDestroy() {
    this.removeOutsidePointerListener();
  },
  methods: {
    handleShow() {
      this.refreshPickerTranslations();
      // 工作台打开表情面板时监听捕获阶段，外层组件拦截 click 也能正常收起。
      if (this.closeOnOutsidePointer) document.addEventListener("pointerdown", this.handleOutsidePointerDown, true);
    },
    refreshPickerTranslations() {
      this.pickerVersion += 1;
    },
    removeOutsidePointerListener() {
      document.removeEventListener("pointerdown", this.handleOutsidePointerDown, true);
    },
    handleOutsidePointerDown(event) {
      const popover = this.$refs.popover;
      if (!popover?.showPopper) return;
      // Element UI 将面板挂在 body；按钮与面板分别判断，保留面板内操作和按钮自身的切换。
      if (popover.referenceElm?.contains(event.target) || popover.$refs.popper?.contains(event.target)) return;
      this.close();
    },
    // 通过组件方法统一关闭弹层，调用方不必访问 Element UI 的内部子组件。
    close() {
      this.removeOutsidePointerListener();
      this.$refs.popover.showPopper = false;
    },
    selectEmoji(emoji) {
      // 选中后先关闭面板，再把 v-emoji-picker 返回的数据交给输入组件。
      this.close();
      this.$emit("select", emoji);
    },
  },
};
</script>
